import { factory, sequence } from 'stahlwerk';

export const createTeamMember = factory({
  crewId: sequence(),
  userId: sequence(),
  teamId: sequence(),
});
